<template>
  <div>
    <div class="air__utils__heading">
      <h5>Product Transactions</h5>
    </div>
    <div class="row justify-content-center" v-if="pagepermission.viewable">
      <div class="col-xl-12">
        <div class="row align-items-center mb-2">
          <div class="col-9 mb-2">
          <!-- Transaction Type Select -->
            <div class="row align-items-center">
              <div class="col-md-3 col-12">
                <a-select
                  size="large"
                  style="width: 100%"
                  placeholder="All Sessions"
                  optionFilterProp="children"
                  v-model="selectedSession"
                  :filterOption="false"
                  :defaultValue="undefined"
                  @change="handleSessionChange"
                >
                  <template v-for="session in schoolSessions">
                    <a-select-option :value="session.id" :key="session.id">
                      {{session.name}} <small class="text-primary ml-1" v-if="session.is_current">Current</small>
                    </a-select-option>
                  </template>
                </a-select>
              </div>
              <div class="col-md-3 col-12">
                <a-spin :spinning="sectionSpinning">
                  <a-select
                    size="large"
                    v-model="selectedType"
                    placeholder="All Types"
                    optionFilterProp="children"
                    style="width: 100%"
                    @change="handleTypeChange"
                    :filterOption="false"
                    :defaultValue="undefined"
                    :disabled="false"
                  >
                    <a-select-option value="undefined">All Types</a-select-option>
                    <a-select-option value="In">In</a-select-option>
                    <a-select-option value="Out">Out</a-select-option>
                  </a-select>
                </a-spin>
              </div>
              <!-- Product Search -->
              <div class="col-md-6 col-12" v-if="!selectedRowKeys.length">
                <div class="text-right">
                  <a-input-search
                    placeholder="Search Product..."
                    size="large"
                    v-model="search"
                    @search="searchProduct"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-3 text-right mb-2" v-if="pagepermission.insertable">
            <div class="d-inline-flex flex-row">
              <div class="mr-2">
                <bulk-transaction />
              </div>
              <div>
                <a
                  class="btn btn-with-addon"
                  style="background-color: #107c41; color: #fff;"
                  :loading="loading"
                  @click="handleExport"
                >
                <span class="btn-addon">
                  <i class="btn-addon-icon fe fe-download" />
                </span>
                  {{ loading ? 'Exporting...' : 'Export' }}
                </a>
              </div>
            </div>
          </div>
<!--          <div class="col-md-6 col-12 mb-2 text-md-right" v-else>
            <a href="javascript:;" class="btn btn btn-danger btn-with-addon"
              @click="handleDeleteSelected"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-trash" />
              </span>
              Delete Selected
            </a>
          </div>-->
        </div>
        <div class="card">
          <div class="card-body">
            <product-transactions-table :rolesetting="pagepermission" :data="data" :loading="loading" :session="selectedSession" @updateTable="handleUpdateTable" @selectChange="handleTableSelect"/>
          </div>
        </div>
        <div class="text-right">
          <a-pagination
              showSizeChanger
              @showSizeChange="onShowSizeChange"
              :total="meta.total"
              :pageSize.sync="pageSize"
              v-model="current"
              @change="onChange"
            >
          </a-pagination>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <p class="error">You don't have permission to use this feature.</p>
    </div>
  </div>
</template>

<script>
import ProductTransactionsTable from '@/components/inventory/transactions/Table/index'
// import StudentsTable from '@/components/student/Table/index'
// import AddStudent from '@/components/student/Forms/Add/index'
// import BulkUploadStudent from '@/components/student/Forms/Bulk/index'
import BulkTransaction from '@/components/inventory/transactions/BulkTransaction/index'

import { debounce, find } from 'lodash'
// const pagename = 'student'
export default {
  components: {
    ProductTransactionsTable,
    BulkTransaction,
    // StudentsTable,
    // AddStudent,
    // BulkUploadStudent,
  },
  beforeMount: function () {
    let rc = this.$roleutility.checkpermission('inventory', 22)
    rc.then(data => {
      console.log('RoleCheck!Data processed. ', data)
      this.pagepermission = data.pagePermission
    })
  },
  mounted: function() {
    this.$http.get('/api/session')
      .then(({ data }) => {
        this.schoolSessions = data.data
        this.selectedSession = find(data.data, ['is_current', 1]).id
        this.getProductTransactions()
      })
      .catch(error => {
        console.log(error)
        this.$neoNotify.error(error)
      })
  },
  created() {
    this.searchProduct = debounce(this.searchProduct, 500)
  },
  computed: {
    currentSession: function() {
      const session = find(this.schoolSessions, ['is_current', 1])
      return session
    },
  },
  watch: {
    currentSession: function (val) {
      this.selectedSession = val.id
    },
  },
  data: function() {
    return {
      loading: true,
      visible: false,
      data: [],
      meta: {},
      schoolClasses: [],
      sections: [],
      schoolSessions: [],
      current: 1,
      pageSize: 10,
      selectedClass: undefined,
      selectedType: undefined,
      selectedSession: undefined,
      sectionSpinning: false,
      classSpinning: false,
      search: null,
      selectedRowKeys: [],
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
    }
  },
  methods: {
    handleTableSelect: function(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    getProductTransactions: function(isSearch) {
      this.selectedRowKeys = []
      this.loading = true

      let page = this.current
      if (isSearch) {
        page = 1
        this.current = 1
      }
      this.$http.get('/api/inventory/transaction/all', {
        params: {
          limit: this.pageSize,
          page: page,
          search: this.search,
          transaction_type: this.selectedType === 'undefined' ? undefined : this.selectedType,
          session_id: this.selectedSession,
        },
      }).then(({ data }) => {
        this.loading = false
        this.data = data.data
        this.meta = data.meta
      })
    },
    searchProduct: function(value) {
      this.search = value
      this.getProductTransactions(true)
    },
    onChangeSearchProducts: function(e) {
      this.search = e.target.value
      this.getProductTransactions(true)
    },
    handleCreated: function() {
      this.getProductTransactions()
    },
    handleUpdateTable: function() {
      this.getProductTransactions()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getProductTransactions()
    },
    onChange(current) {
      this.current = current
      this.getProductTransactions()
    },
    /* getClasses() {
      this.classSpinning = true
      this.$http.get('/api/class', {
        params: {
          session_id: this.selectedSession,
        },
      })
        .then(({ data }) => {
          this.schoolClasses = data.data
          this.classSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    }, */
    /* handleClassSelect(value) {
      this.selectedSection = undefined
      if (value) {
        this.sectionSpinning = true
        this.getClassSections(value)
      }
      this.getProductTransactions()
    }, */
    /* getClassSections(value) {
      this.$http.get(`/api/section/class/${value}`, {
        params: {
          session_id: this.selectedSession,
        },
      })
        .then(({ data }) => {
          this.sections = data.data
          this.sectionSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    }, */
    handleTypeChange (value) {
      if (value) {
        this.selectedType = value
        this.getProductTransactions()
      } else {
        this.selectedType = undefined
        this.getProductTransactions()
      }
    },
    handleExport() {
      this.loading = true
      this.$http
        .get('/api/inventory/transaction/export', {
          responseType: 'arraybuffer',
          params: {
            session_id: this.selectedSession,
          },
        })
        .then(({ data }) => {
          let blob = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          })
          this.loading = false
          this.$notification['info']({
            message: 'Product Transaction export started!',
            description: `Product Transaction export  has started! You will be notified once it is completed!`,
          })

          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'ProductTransactionExport.xlsx'
          link.click()
        })
        .catch((error) => {
          this.loading = false
          this.$neoNotify.error(error)
        })
    },
    handleSessionChange (value) {
      if (value) {
        this.selectedSession = value
      } else {
        this.selectedSession = this.currentSession
      }
      this.getProductTransactions()
    },
    /* handleDeleteSelected() {
      this.$confirm({
        title: `Are you sure?`,
        content: `Clicking Yes will delete the selected students?`,
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/students', {
              params: {
                student_ids: this.selectedRowKeys,
              },
            })
            .then(() => {
              this.handleUpdateTable()
              this.selectedRowKeys = []
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Deleted Successfully!',
                description: 'The selected students were deleted successfully',
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    }, */
  },
}
</script>
<style>
.error { padding: 25px 5px; }
</style>
